<div class="p-6 space-y-6" id="page-usuarios">
  <div class="items-center justify-between flex">
    <div>
      <h2 class="text-xl font-bold text-gray-900 dark:text-white">Usuarios</h2>
      <p class="text-sm text-gray-400 dark:text-gray-500">Usuarios de los clientes de la consultoría</p>
    </div>
    <button type="button" class="btn btn-primary gap-2">
      <svg class="w-4 h-4"><use href="/svg/sprite.svg#plus-sign"/></svg>
      Nuevo Usuario
    </button>
  </div>
  <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-800
            overflow-hidden">
    <div class="px-4 py-3 border-b border-gray-100 dark:border-gray-800 flex flex-col sm:flex-row gap-3">
      <label class="input w-full sm:flex-1">
        <svg class="w-4 h-4 opacity-50"><use href="/svg/sprite.svg#search-icon"/></svg>
        <input type="text" placeholder="Buscar usuario..." class="grow" />
      </label>
      <select class="select w-full sm:w-auto">
        <option>Cliente: Todos</option>
        <option>Constructora Azteca</option>
        <option>Inmobiliaria del Norte</option>
      </select>
    </div>
    <div class="overflow-x-auto">
      <table class="w-full">
        <thead class="bg-gray-50 dark:bg-gray-800/50">
          <tr>
            <th class="text-left text-xs font-semibold text-gray-400 tracking-wider px-6 py-3 dark:text-gray-500
                      uppercase">Usuario</th>
            <th class="text-left text-xs font-semibold text-gray-400 tracking-wider px-4 py-3 dark:text-gray-500
                      uppercase">Cliente</th>
            <th class="text-left text-xs font-semibold text-gray-400 tracking-wider px-4 py-3 dark:text-gray-500
                      uppercase">Correo</th>
            <th class="text-left text-xs font-semibold text-gray-400 tracking-wider px-4 py-3 dark:text-gray-500
                      uppercase">Rol</th>
            <th class="text-left text-xs font-semibold text-gray-400 tracking-wider px-4 py-3 dark:text-gray-500
                      uppercase">Estado</th>
            <th class="text-left text-xs font-semibold text-gray-400 tracking-wider px-4 py-3 dark:text-gray-500
                      uppercase">Acciones</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-50 dark:divide-gray-800">
          <tr class="hover:bg-gray-50 dark:hover:bg-gray-800/50 transition">
            <td class="px-6 py-4">
              <div class="items-center flex gap-3">
                <img alt="" src="/img/default-avatar.png" class="object-cover w-8 h-8 rounded-lg" />
                <span class="text-sm font-medium text-gray-800 dark:text-gray-200">Roberto Jiménez</span>
              </div>
            </td>
            <td class="px-4 py-4 text-sm text-gray-600 dark:text-gray-400">Constructora Azteca</td>
            <td class="px-4 py-4 text-sm text-gray-600 dark:text-gray-400">r.jimenez&#64;azteca.mx</td>
            <td class="px-4 py-4">
              <span class="text-xs bg-green-100 dark:bg-green-900/30 text-green-600 px-2 py-0.5 rounded-lg
                        font-medium dark:text-green-400">Cliente</span>
            </td>
            <td class="px-4 py-4">
              <span class="text-xs bg-green-100 dark:bg-green-900/30 text-green-600 px-2 py-0.5 rounded-lg
                        font-medium dark:text-green-400">Activo</span>
            </td>
            <td class="px-4 py-4">
              <div class="flex gap-1">
                <button type="button" class="btn btn-ghost btn-square btn-sm">
                  <svg class="w-4 h-4"><use href="/svg/sprite.svg#pencil-icon"/></svg>
                </button>
                <button type="button" class="btn btn-ghost btn-square btn-sm text-error">
                  <svg class="w-4 h-4"><use href="/svg/sprite.svg#trash-stroke-icon"/></svg>
                </button>
              </div>
            </td>
          </tr>
          <tr class="hover:bg-gray-50 dark:hover:bg-gray-800/50 transition">
            <td class="px-6 py-4">
              <div class="items-center flex gap-3">
                <img alt="" src="/img/default-avatar.png" class="object-cover w-8 h-8 rounded-lg" />
                <span class="text-sm font-medium text-gray-800 dark:text-gray-200">Ana Torres Vega</span>
              </div>
            </td>
            <td class="px-4 py-4 text-sm text-gray-600 dark:text-gray-400">Inmobiliaria del Norte</td>
            <td class="px-4 py-4 text-sm text-gray-600 dark:text-gray-400">a.torres&#64;inmonorte.mx</td>
            <td class="px-4 py-4">
              <span class="text-xs bg-green-100 dark:bg-green-900/30 text-green-600 px-2 py-0.5 rounded-lg
                        font-medium dark:text-green-400">Cliente</span>
            </td>
            <td class="px-4 py-4">
              <span class="text-xs bg-green-100 dark:bg-green-900/30 text-green-600 px-2 py-0.5 rounded-lg
                        font-medium dark:text-green-400">Activo</span>
            </td>
            <td class="px-4 py-4">
              <div class="flex gap-1">
                <button type="button" class="btn btn-ghost btn-square btn-sm">
                  <svg class="w-4 h-4"><use href="/svg/sprite.svg#pencil-icon"/></svg>
                </button>
                <button type="button" class="btn btn-ghost btn-square btn-sm text-error">
                  <svg class="w-4 h-4"><use href="/svg/sprite.svg#trash-stroke-icon"/></svg>
                </button>
              </div>
            </td>
          </tr>
          <tr class="hover:bg-gray-50 dark:hover:bg-gray-800/50 transition">
            <td class="px-6 py-4">
              <div class="items-center flex gap-3">
                <img alt="" src="/img/default-avatar.png" class="object-cover w-8 h-8 rounded-lg" />
                <span class="text-sm font-medium text-gray-800 dark:text-gray-200">Mauricio Luna</span>
              </div>
            </td>
            <td class="px-4 py-4 text-sm text-gray-600 dark:text-gray-400">TechSoluciones MX</td>
            <td class="px-4 py-4 text-sm text-gray-600 dark:text-gray-400">m.luna&#64;techsol.mx</td>
            <td class="px-4 py-4">
              <span class="text-xs bg-green-100 dark:bg-green-900/30 text-green-600 px-2 py-0.5 rounded-lg
                        font-medium dark:text-green-400">Cliente</span>
            </td>
            <td class="px-4 py-4">
              <span class="text-xs bg-gray-100 dark:bg-gray-800 text-gray-500 px-2 py-0.5 rounded-lg font-medium
                        dark:text-gray-400">Inactivo</span>
            </td>
            <td class="px-4 py-4">
              <div class="flex gap-1">
                <button type="button" class="btn btn-ghost btn-square btn-sm">
                  <svg class="w-4 h-4"><use href="/svg/sprite.svg#pencil-icon"/></svg>
                </button>
                <button type="button" class="btn btn-ghost btn-square btn-sm text-error">
                  <svg class="w-4 h-4"><use href="/svg/sprite.svg#trash-stroke-icon"/></svg>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

